import React from 'react';
import styled from 'styled-components';

import { RadioProps } from '@/components/Radio/types';

import { ReactComponent as RadioIcon } from './radio.svg';
import { ReactComponent as RadIconChecked } from './radioChecked.svg';

const Radio: React.FC<RadioProps> = ({ checked, onChange, value }) => {
  return (
    <Component>
      {checked ? <RadIconChecked /> : <RadioIcon />}
      <Input
        type="radio"
        value={value}
        checked={checked}
        onChange={() => onChange()}
      />
    </Component>
  );
};

export default Radio;

const Component = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Input = styled.input`
  cursor: inherit;
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  z-index: 1;
`;
